export default __webpack_public_path__ + "static/media/14.372617da.png";